module.exports = __webpack_public_path__ + "static/assets/7696a504b61394f1d39fd510d22ee064.gif";